'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _throttle2 = require('lodash/throttle');

var _throttle3 = _interopRequireDefault(_throttle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stickyPositioner = function stickyPositioner(_ref) {
  var elem = _ref.elem,
      footer = _ref.footer,
      _ref$topThreshold = _ref.topThreshold,
      topThreshold = _ref$topThreshold === undefined ? 15 : _ref$topThreshold,
      _ref$footerThreshold = _ref.footerThreshold,
      footerThreshold = _ref$footerThreshold === undefined ? 30 : _ref$footerThreshold,
      _ref$appSelector = _ref.appSelector,
      appSelector = _ref$appSelector === undefined ? '.l-app-content' : _ref$appSelector,
      _ref$contextualSelect = _ref.contextualSelector,
      contextualSelector = _ref$contextualSelect === undefined ? '.l-contextual' : _ref$contextualSelect;

  var elemRect = elem.getBoundingClientRect();
  var div = document.createElement('div');
  var parentNode = elem.parentNode;
  var app = document.querySelector(appSelector);
  var contextual = document.querySelector(contextualSelector);
  parentNode.insertBefore(div, elem);
  return function () {
    var contextualHeight = contextual.getBoundingClientRect().height;
    var appHeight = app.getBoundingClientRect().height;

    var _div$getBoundingClien = div.getBoundingClientRect(),
        top = _div$getBoundingClien.top;

    if (top <= topThreshold && appHeight > contextualHeight) {
      var footerRect = footer.getBoundingClientRect();
      if (footerRect.top - elemRect.height - footerThreshold > 0) {
        elem.classList.add('sticky-is--fixed');
        elem.classList.remove('sticky-is--abs');
        elem.style.position = 'fixed';
        elem.style.top = topThreshold + 'px';
        elem.style.bottom = 'auto';
      } else {
        elem.classList.add('sticky-is--abs');
        elem.classList.remove('sticky-is--fixed');
        elem.style.position = 'absolute';
        elem.style.top = 'auto';
        elem.style.bottom = '-' + (footerThreshold - 10) + 'px';
      }
    } else {
      elem.classList.remove('sticky-is--abs');
      elem.classList.remove('sticky-is--fixed'); // thanks IE11
      elem.style.position = 'static';
      elem.style.top = 'auto';
      elem.style.bottom = 'auto';
    }
  };
}; /* eslint-disable no-undef */


var stickyPositionerWithSupport = function stickyPositionerWithSupport(_ref2) {
  var elem = _ref2.elem,
      _ref2$topThreshold = _ref2.topThreshold,
      topThreshold = _ref2$topThreshold === undefined ? 15 : _ref2$topThreshold,
      _ref2$footerThreshold = _ref2.footerThreshold,
      footerThreshold = _ref2$footerThreshold === undefined ? 40 : _ref2$footerThreshold,
      _ref2$appSelector = _ref2.appSelector,
      appSelector = _ref2$appSelector === undefined ? '.l-app-content' : _ref2$appSelector,
      _ref2$contextualSelec = _ref2.contextualSelector,
      contextualSelector = _ref2$contextualSelec === undefined ? '.l-contextual' : _ref2$contextualSelec;

  var afterDiv = document.createElement('div');
  var parentNode = elem.parentNode;
  var app = document.querySelector(appSelector);
  var contextual = document.querySelector(contextualSelector);
  parentNode.insertBefore(afterDiv, null);
  elem.style.position = 'sticky';
  elem.style.position = '-webkit-sticky';
  elem.style.position = '-ms-sticky';
  elem.style.top = topThreshold + 'px';
  var contextualHeight = contextual.getBoundingClientRect().height;
  return function () {
    var appHeight = app.getBoundingClientRect().height;
    if (appHeight > contextualHeight) {
      var afterHeight = appHeight - (elem.previousElementSibling.offsetTop + elem.previousElementSibling.getBoundingClientRect().height + elem.getBoundingClientRect().height + footerThreshold);
      afterDiv.style.height = afterHeight + 'px';
    } else {
      afterDiv.style.height = '0px';
    }
  };
};

var positionStickySupport = function positionStickySupport() {
  var el = document.createElement('a');
  var mStyle = el.style;
  mStyle.cssText = 'position:sticky;position:-webkit-sticky;position:-ms-sticky;';
  return mStyle.position.indexOf('sticky') !== -1;
};

var init = function init(_ref3) {
  var elem = _ref3.elem,
      footer = _ref3.footer,
      _ref3$throttlingMs = _ref3.throttlingMs,
      throttlingMs = _ref3$throttlingMs === undefined ? 100 : _ref3$throttlingMs,
      other = (0, _objectWithoutProperties3.default)(_ref3, ['elem', 'footer', 'throttlingMs']);

  var supported = positionStickySupport();
  if (supported) {
    var _sPlacer = stickyPositionerWithSupport((0, _extends3.default)({ elem: elem, footer: footer }, other));
    _sPlacer();
    var _throttled = (0, _throttle3.default)(_sPlacer, throttlingMs);
    window.addEventListener('scroll', _throttled);
    window.addEventListener('resize', _throttled);
    return {
      removeEvents: function removeEvents() {
        window.addEventListener('scroll', _throttled);
        window.removeEventListener('resize', _throttled);
      }
    };
  }
  // fallback
  var sPlacer = stickyPositioner((0, _extends3.default)({ elem: elem, footer: footer }, other));
  sPlacer();
  var throttled = (0, _throttle3.default)(sPlacer, throttlingMs);
  window.addEventListener('scroll', throttled);
  window.addEventListener('resize', throttled);
  return {
    removeEvents: function removeEvents() {
      // useful when you have stuff like client side routing or componentWillUnmount
      window.removeEventListener('scroll', throttled);
      window.removeEventListener('resize', throttled);
    }
  };
};

exports.default = init;